import React from "react";
import paragraphs from "./seller-agreement-en.json";

const sectionHeadings = new Set([
    "Definitions",
    "I. Transaction process",
    "II. Warranty of full copyright",
    "III. License term and territory",
    "IV. Uploaded works",
    "V. Delisting or deletion of works",
    "VI. Distribution and pricing",
    "VII. Revenue sharing",
    "VIII. Withdrawal",
    "IX. Copyright",
    "X. Disclaimer",
    "XI. Violations and their handling",
    "XII. Miscellaneous provisions",
    "Translator's Notes",
]);

export default function EnglishSellerAgreement() {
    const [title, ...body] = paragraphs;

    return (
        <div className="mypageContents aboutContents">
            <div className="mypageContents__inner2">
                <header className="mainHeading">
                    <h1 className="mainHeading__title">{title}</h1>
                </header>
                <div className="aboutBox">
                    <div className="aboutBox__inner">
                        {body.map((text, index) =>
                            sectionHeadings.has(text) ? (
                                <h3 className="termsof__item__title" key={index}>
                                    {text}
                                </h3>
                            ) : (
                                <p key={index}>{text}</p>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
